export const formatAvailabilityFreshness = (
  value: string | undefined,
  now: Date = new Date(),
): string => {
  if (!value) return 'not recently confirmed';

  const updatedAt = new Date(value);
  if (Number.isNaN(updatedAt.getTime())) return 'not recently confirmed';

  const minutes = Math.max(0, Math.floor((now.getTime() - updatedAt.getTime()) / 60_000));
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} min ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} ${days === 1 ? 'day' : 'days'} ago`;

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
  }).format(updatedAt);
};
